import React, { useState, useEffect } from 'react';
import Loader from './components/loader';
import Header from './components/Header';
import Cart from './pages/Cart'
import About from './pages/Aboutus'
import CartPage from './pages/Cheackout'
import Contact from './pages/Contactus'
import ProductCard from './pages/Productdescription'
import Footer from './components/footer';
import Engment from './pages/Engagement'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/home';
import './App.css';
import Collection from './pages/Collection';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading (e.g., fetching data)
    setTimeout(() => {
      setIsLoading(false);
    }, 2000); // 2 seconds delay
  }, []);

  return (
    <BrowserRouter>
      <div className="App">
        {isLoading && <Loader />} {/* Show loader only when isLoading is true */}
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/product/:sku" element={<ProductCard />} />
          <Route path="/collection/:url" element={<Collection />} />
          <Route path="/checkout" element={<CartPage />} />
          <Route path="/About" element={<About />} />
          <Route path="/engament" element={<Engment />} />
          <Route path="/Contact" element={<Contact />} />

          {/* Add more routes here */}

        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;